import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'

import { Route } from '~/routes/_centered-layout/token-to-ls'
import { useAccountStore } from '~/stores/account'
import { useSettingsStore } from '~/stores/settings'

import { LS_JWT_KEY } from '../const/api'

export const QueryTokenToLocalStorage = () => {
  const navigate = useNavigate()
  const { token, subscriptionId, account } = Route.useSearch()
  const setAccount = useAccountStore(state => state.patchAccount)
  const setLanguagesIfEmpty = useSettingsStore(state => state.setLanguagesIfEmpty)

  useEffect(() => {
    localStorage.setItem(LS_JWT_KEY, token)
    // TODO: set push notifications and webauthn registered
    setAccount({ ...account, coins: account.coins ?? 0 })
    setLanguagesIfEmpty(account.lastSelectedLanguages)

    if (subscriptionId) {
      void navigate({ to: '/cards', replace: true })

      return
    }

    void navigate({ to: '/subscription', replace: true })
  }, [account, navigate, setAccount, setLanguagesIfEmpty, subscriptionId, token])

  return null
}
